module.exports = __webpack_public_path__ + "static/media/message.b86ea9fb.svg";